import { cn } from '@/lib/utils'

/** 卡内表格外壳：同 dashboard-01 data-table 的圆角描边，不带 ui/table 的 90vh 高度 */
export function CeoTable({ className, children }) {
  return (
    <div className="relative w-full overflow-auto rounded-lg border">
      <table className={cn('w-full caption-bottom text-sm', className)}>{children}</table>
    </div>
  )
}
